module.exports = __webpack_public_path__ + "static/1_ec2-f1ae0b9d8c0cfac3329edf8e7cb93e77.jpg";